import { CommonUtilities } from '../../commonUtils';

export default class templateServices {
    static getDSPList() {
        var url = 'client/getClientDSP';
        return CommonUtilities.getData(url);
    }

    static genericAPIListing(param: any) {
        var url = 'common/genericListing';
        return CommonUtilities.postData(url, param)
    }

    static createTemplate(param: any) {
        var url = 'common/createTemplate';
        return CommonUtilities.postData(url, param)
    }
}